import Endpoint from "../../services/api/endpoint";
import { IDossierTask } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IDossierTask>(Endpoint.FutureTasksTeamChange);